var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-wizard"},_vm._l((_vm.numberOfSlots),function(index){return _c('div',{key:index,class:("form-part form-part-" + index + " " + (index === _vm.currentSlot ? 'active' : ''))},[_vm._t(("slot-" + index))],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }